import { 
  AUTH_START, 
  AUTH_SUCCESS, 
  AUTH_FAILURE, 
  RESTORE_SESSION,
  REGISTER_START,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  SERVICE_LOGIN_SUCCESS,
  SET_USER_DETAILS,
  LOGOUT,
  SET_SERVICE_NUMBER,
  SET_USER_IMAGE,
  UPLOAD_IMAGE_START,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_FAILURE,
  UPDATE_USER_START,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  CHANGE_PASSWORD_START,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE
} from "../actions/authActions";

const initialState = {
  loading: false,
  data: null,
  error: null,
  userData: null,
  isAuthenticated: false,
  phoneNumber: null,
  serviceNo: null,
  authKey: null,
  loginMethod: null,
  registerLoading: false,
  registerError: null,
  userImage: null,
  uploadingImage: false,
  uploadImageError: null,
  updatingUser: false,
  updateUserError: null,
  changingPassword: false,
  changePasswordError: null,
  employeeName: "",
  department: "",
  role: ""
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_START:
      return { ...state, loading: true, error: null };
      
    case RESTORE_SESSION:
      return {
        ...state,
        isAuthenticated: true,
        phoneNumber: action.payload.phoneNumber || null,
        serviceNo: action.payload.serviceNo || state.serviceNo,
        authKey: action.payload.authKey || null,
        userData: action.payload.userData,
        loginMethod: action.payload.loginMethod,
        data: action.payload.phoneNumber || action.payload.serviceNo,
        loading: false,
        error: null,
        employeeName: action.payload.userData?.Name || state.employeeName,
        department: action.payload.userData?.Department || state.department,
        role: action.payload.userData?.Designation || state.role
      };
      
    case SET_USER_DETAILS:
      return {
        ...state,
        userData: action.payload,
        employeeName: action.payload.Name || "",
        department: action.payload.Department || "",
        role: action.payload.Designation || "",
        error: null
      };
      
    case SET_SERVICE_NUMBER:
      return {
        ...state,
        serviceNo: action.payload
      };
      
    case SET_USER_IMAGE:
      return {
        ...state,
        userImage: action.payload
      };
      
    case UPLOAD_IMAGE_START:
      return {
        ...state,
        uploadingImage: true,
        uploadImageError: null
      };
      
    case UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        uploadingImage: false,
        userImage: action.payload,
        uploadImageError: null
      };
      
    case UPLOAD_IMAGE_FAILURE:
      return {
        ...state,
        uploadingImage: false,
        uploadImageError: action.payload
      };
      
    case AUTH_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        data: action.payload.phoneNumber, 
        error: null,
        isAuthenticated: true,
        phoneNumber: action.payload.phoneNumber,
        serviceNo: action.payload.serviceNo || state.serviceNo,
        loginMethod: 'phone'
      };
    
    case SERVICE_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.serviceNo,
        error: null,
        isAuthenticated: true,
        serviceNo: action.payload.serviceNo,
        authKey: action.payload.authKey,
        userData: action.payload.userData,
        employeeName: action.payload.userData?.Name || state.employeeName,
        department: action.payload.userData?.Department || state.department,
        role: action.payload.userData?.Designation || state.role,
        loginMethod: 'service'
      };
      
    case AUTH_FAILURE:
      return { 
        ...state, 
        loading: false, 
        error: action.payload,
        isAuthenticated: false 
      };
    
    case REGISTER_START:
      return {
        ...state,
        registerLoading: true,
        registerError: null
      };
      
    case REGISTER_SUCCESS:
      return {
        ...state,
        registerLoading: false,
        registerError: null
      };
      
    case REGISTER_FAILURE:
      return {
        ...state,
        registerLoading: false,
        registerError: action.payload
      };
    
    case UPDATE_USER_START:
      return {
        ...state,
        updatingUser: true,
        updateUserError: null
      };
      
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        updatingUser: false,
        userData: { ...state.userData, ...action.payload },
        employeeName: action.payload.Name || state.employeeName,
        department: action.payload.Department || state.department,
        role: action.payload.role || state.role,
        updateUserError: null
      };
      
    case UPDATE_USER_FAILURE:
      return {
        ...state,
        updatingUser: false,
        updateUserError: action.payload
      };
    
    case CHANGE_PASSWORD_START:
      return {
        ...state,
        changingPassword: true,
        changePasswordError: null
      };
      
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changingPassword: false,
        changePasswordError: null
      };
      
    case CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        changingPassword: false,
        changePasswordError: action.payload
      };
    
    case LOGOUT:
      return {
        ...initialState
      };
    
    default:
      return state;
  }
};

export default authReducer;


// import { 
//   AUTH_START, 
//   AUTH_SUCCESS, 
//   AUTH_FAILURE, 
//   RESTORE_SESSION,
//   REGISTER_START,
//   REGISTER_SUCCESS,
//   REGISTER_FAILURE,
//   SERVICE_LOGIN_SUCCESS,
//   SET_USER_DETAILS,
//   LOGOUT,
//   SET_SERVICE_NUMBER,
//   SET_USER_IMAGE,
//   UPLOAD_IMAGE_START,
//   UPLOAD_IMAGE_SUCCESS,
//   UPLOAD_IMAGE_FAILURE
// } from "../actions/authActions";

// const initialState = {
//   loading: false,
//   data: null,
//   error: null,
//   userData: null,
//   isAuthenticated: false,
//   phoneNumber: null,
//   serviceNo: null,
//   authKey: null,
//   loginMethod: null,
//   registerLoading: false,
//   registerError: null,
//   userImage: null,
//   uploadingImage: false,
//   uploadImageError: null,
//   employeeName: "",
//   department: "",
//   role: ""
// };

// const authReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case AUTH_START:
//       return { ...state, loading: true, error: null };
      
//     case RESTORE_SESSION:
//       return {
//         ...state,
//         isAuthenticated: true,
//         phoneNumber: action.payload.phoneNumber || null,
//         serviceNo: action.payload.serviceNo || state.serviceNo,
//         authKey: action.payload.authKey || null,
//         userData: action.payload.userData,
//         loginMethod: action.payload.loginMethod,
//         data: action.payload.phoneNumber || action.payload.serviceNo,
//         loading: false,
//         error: null,
//         employeeName: action.payload.userData?.Name || state.employeeName,
//         department: action.payload.userData?.Department || state.department,
//         role: action.payload.userData?.Designation || state.role
//       };
      
//     case SET_USER_DETAILS:
//       return {
//         ...state,
//         userData: action.payload,
//         employeeName: action.payload.Name || "",
//         department: action.payload.Department || "",
//         role: action.payload.Designation || "",
//         error: null
//       };
      
//     case SET_SERVICE_NUMBER:
//       return {
//         ...state,
//         serviceNo: action.payload
//       };
      
//     case SET_USER_IMAGE:
//       return {
//         ...state,
//         userImage: action.payload
//       };
      
//     case UPLOAD_IMAGE_START:
//       return {
//         ...state,
//         uploadingImage: true,
//         uploadImageError: null
//       };
      
//     case UPLOAD_IMAGE_SUCCESS:
//       return {
//         ...state,
//         uploadingImage: false,
//         userImage: action.payload,
//         uploadImageError: null
//       };
      
//     case UPLOAD_IMAGE_FAILURE:
//       return {
//         ...state,
//         uploadingImage: false,
//         uploadImageError: action.payload
//       };
      
//     case AUTH_SUCCESS:
//       return { 
//         ...state, 
//         loading: false, 
//         data: action.payload.phoneNumber, 
//         error: null,
//         isAuthenticated: true,
//         phoneNumber: action.payload.phoneNumber,
//         serviceNo: action.payload.serviceNo || state.serviceNo,
//         loginMethod: 'phone'
//       };
    
//     case SERVICE_LOGIN_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         data: action.payload.serviceNo,
//         error: null,
//         isAuthenticated: true,
//         serviceNo: action.payload.serviceNo,
//         authKey: action.payload.authKey,
//         userData: action.payload.userData,
//         employeeName: action.payload.userData?.Name || state.employeeName,
//         department: action.payload.userData?.Department || state.department,
//         role: action.payload.userData?.Designation || state.role,
//         loginMethod: 'service'
//       };
      
//     case AUTH_FAILURE:
//       return { 
//         ...state, 
//         loading: false, 
//         error: action.payload,
//         isAuthenticated: false 
//       };
    
//     case REGISTER_START:
//       return {
//         ...state,
//         registerLoading: true,
//         registerError: null
//       };
      
//     case REGISTER_SUCCESS:
//       return {
//         ...state,
//         registerLoading: false,
//         registerError: null
//       };
      
//     case REGISTER_FAILURE:
//       return {
//         ...state,
//         registerLoading: false,
//         registerError: action.payload
//       };
    
//     case LOGOUT:
//       return {
//         ...initialState
//       };
    
//     default:
//       return state;
//   }
// };

// export default authReducer;

















// import { 
//   AUTH_START, 
//   AUTH_SUCCESS, 
//   AUTH_FAILURE, 
//   LOAD_USER_DATA_SUCCESS, 
//   LOAD_USER_DATA_FAILURE,
//   RESTORE_SESSION,
//   REGISTER_START,
//   REGISTER_SUCCESS,
//   REGISTER_FAILURE,
//   SERVICE_LOGIN_SUCCESS
// } from "../actions/authActions";

// const initialState = {
//   loading: false,
//   data: null,
//   error: null,
//   userData: null,
//   isAuthenticated: false,
//   phoneNumber: null,
//   serviceNo: null,
//   authKey: null,
//   loginMethod: null,
//   registerLoading: false,
//   registerError: null
// };

// const authReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case AUTH_START:
//       return { ...state, loading: true, error: null };
      
//     case RESTORE_SESSION:
//       return {
//         ...state,
//         isAuthenticated: true,
//         phoneNumber: action.payload.phoneNumber || null,
//         serviceNo: action.payload.serviceNo || null,
//         authKey: action.payload.authKey || null,
//         userData: action.payload.userData,
//         loginMethod: action.payload.loginMethod,
//         data: action.payload.phoneNumber || action.payload.serviceNo,
//         loading: false,
//         error: null
//       };
      
//     case LOAD_USER_DATA_SUCCESS:
//       return {
//         ...state,
//         userData: action.payload,
//         loading: false,
//         error: null,
//       };
      
//     case "SET_USER_DATA":
//       return {
//         ...state,
//         userData: action.payload,
//       };
      
//     case LOAD_USER_DATA_FAILURE:
//       return {
//         ...state,
//         userData: null,
//         loading: false,
//         error: action.payload,
//       };
      
//     case AUTH_SUCCESS:
//       return { 
//         ...state, 
//         loading: false, 
//         data: action.payload.phoneNumber, 
//         error: null,
//         isAuthenticated: true,
//         phoneNumber: action.payload.phoneNumber,
//         loginMethod: 'phone'
//       };
    
//     case SERVICE_LOGIN_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         data: action.payload.serviceNo,
//         error: null,
//         isAuthenticated: true,
//         serviceNo: action.payload.serviceNo,
//         authKey: action.payload.authKey,
//         userData: action.payload.userData,
//         loginMethod: 'service'
//       };
      
//     case AUTH_FAILURE:
//       return { 
//         ...state, 
//         loading: false, 
//         error: action.payload,
//         isAuthenticated: false 
//       };
    
//     case REGISTER_START:
//       return {
//         ...state,
//         registerLoading: true,
//         registerError: null
//       };
      
//     case REGISTER_SUCCESS:
//       return {
//         ...state,
//         registerLoading: false,
//         registerError: null
//       };
      
//     case REGISTER_FAILURE:
//       return {
//         ...state,
//         registerLoading: false,
//         registerError: action.payload
//       };
    
//     case "LOGOUT":
//       return {
//         ...initialState
//       };
    
//     default:
//       return state;
//   }
// };

// export default authReducer;







// import { 
//   AUTH_START, 
//   AUTH_SUCCESS, 
//   AUTH_FAILURE, 
//   LOAD_USER_DATA_SUCCESS, 
//   LOAD_USER_DATA_FAILURE,
//   RESTORE_SESSION 
// } from "../actions/authActions";
// const initialState = {
//   loading: false,
//   data: null,
//   error: null,
//   userData: null,
//   isAuthenticated: false, // Add this field
//   phoneNumber: null // Add this field
// };
// const authReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case AUTH_START:
//       return { ...state, loading: true, error: null };
      
//     case RESTORE_SESSION:
//       return {
//         ...state,
//         isAuthenticated: true,
//         phoneNumber: action.payload.phoneNumber,
//         userData: action.payload.userData,
//         data: action.payload.phoneNumber,
//         loading: false,
//         error: null
//       };
      
//     case LOAD_USER_DATA_SUCCESS:
//       return {
//         ...state,
//         userData: action.payload,
//         loading: false,
//         error: null,
//       };
      
//     case "SET_USER_DATA":
//       return {
//           ...state,
//           userData: action.payload,
//       };
//     case LOAD_USER_DATA_FAILURE:
//       return {
//         ...state,
//         userData: null,
//         loading: false,
//         error: action.payload,
//       };
//     case AUTH_SUCCESS:
//       return { 
//         ...state, 
//         loading: false, 
//         data: action.payload.phoneNumber, 
//         error: null,
//         isAuthenticated: true,
//         phoneNumber: action.payload.phoneNumber
//       };
      
//     case AUTH_FAILURE:
//       return { 
//         ...state, 
//         loading: false, 
//         error: action.payload,
//         isAuthenticated: false 
//       };
    
//     case "LOGOUT":
//       return {
//         ...initialState
//       };
    
//     default:
//       return state;
//   }
// };
// export default authReducer;